import type { ReactNode } from "react";
import { Row } from "./Row";

export function CommaSeparated({ children, maxItems = 3 }: { children: Array<ReactNode>; maxItems?: number }) {
  return <Row>{Array.from(_commaSeparated(children, maxItems))}</Row>;
}

function* _commaSeparated(a: Array<ReactNode>, maxItems: number) {
  const n1 = a.length - 1;
  const ni = Math.min(maxItems - 1, n1);
  for (let i = 0; i <= ni; i++) {
    yield a[i];
    if (i < ni) {
      yield <div key={i}>{",\u00A0"}</div>;
    }
  }
  if (n1 > ni) {
    yield <div key={"..."}>{",\u00A0..."}</div>;
  }
}
